import React, { useEffect, useState } from 'react';
import styles from './ProgramsPage.module.css';
import TableTopHeader from '../../Molecules/TableTopHeader/TableTopHeader';
import { useNavigate } from 'react-router-dom';
import Loader from '../../Molecules/Loader/Loader';
import MajorBoxGroup from '../../Molecules/majorBox/MajorBoxGroup';
import { useDeleteProgram, useFetchDegrees } from '../../../Hooks/Programs';
import { useToast } from '../../Molecules/Custom/CustomToaster/Toast';
import DeletePopup from '../../Molecules/Custom/DeletePopup';
import { debounce } from 'lodash';
import TablePagination from '../../Molecules/Pagination/TablePagination';

const ProgramsPage = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [searchQuery, setSearchQuery] = useState('');
  const {
    data: degreeData,
    refetch: refetchDegreeData,
    isLoading,
  } = useFetchDegrees(pageSize, page, searchQuery);
  const [deletestate, setDeletState] = useState({
    isDelete: false,
    selectedItem: '',
  });
  const itemsPerPage = degreeData?.data?.pageSize;
  const totalItems = degreeData?.data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const { mutate: deleteProgram, isLoading: isDeleteProgram } =
    useDeleteProgram();
  const customizedToast = useToast();

  useEffect(() => {
    handleSearch();
  }, [searchQuery]);

  const handleSearch = debounce(() => {
    refetchDegreeData();
  }, 300);

  useEffect(() => {
    refetchDegreeData();
  }, [page, pageSize]);

  const handleNavigate = (e) => {
    e.preventDefault();
    navigate('/home/programs/add', { state: { mode: 'add' } });
  };

  const handleDelete = (id) => {
    deleteProgram(id, {
      onSuccess: () => {
        customizedToast.open('تم الحذف بنجاح');
        setDeletState((prev) => ({
          isDelete: false,
          selectedItem: '',
        }));
        refetchDegreeData();
      },
      onError: (error) => {},
    });
  };
  return (
    <>
      <div className={styles['table-container']}>
        <TableTopHeader
          search={searchQuery}
          setSearch={setSearchQuery}
          disableControls
          addLabel="برنامج جديد"
          handleOnAdd={(e) => handleNavigate(e)}
        />
        {isLoading ? (
          <Loader />
        ) : (
          <MajorBoxGroup
            degreeData={degreeData?.data?.items}
            setDeletState={setDeletState}
          />
        )}
        <TablePagination
          totalPages={totalPages}
          page={page}
          setPage={setPage}
          itemsPerPage={pageSize}
          setPageSize={setPageSize}
        />
      </div>
      {deletestate.isDelete == true && (
        <DeletePopup
          isLoading={isDeleteProgram}
          handleOnClose={() =>
            setDeletState((prev) => ({
              isDelete: false,
              selectedItem: '',
            }))
          }
          title="برنامج "
          handleDelete={() => handleDelete(deletestate.selectedItem)}
        />
      )}
    </>
  );
};

export default ProgramsPage;
